var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'turnovertype-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      turnovertypes: {
        turnover_class: null,
        turnover_content: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        turnover_class: !!this.turnovertypes.turnover_class,
        turnover_content: !!this.turnovertypes.turnover_content,
        not_input: !!this.turnovertypes.turnover_class && !!this.turnovertypes.turnover_content
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('TURNOVER_CREATE',
          { data: this.turnovertypes, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/turnover_types', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.turnovertypes.turnover_content = utils.emHalf(this.turnovertypes.turnover_content)
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/turnover_types')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/turnovertype-new.js